import Link from "next/link"
//import nameLogoUrl from "../../logos/name-only-two.svg?url"
import Image from "next/image"

const LogoButton = ({ media, className = "" }) => {
  const url = media ? media.data.attributes.url : ""
  const alt = media ? media.data.attributes.alternativeText : 'Browned & Toasted Home'
  const width = media ? media.data.attributes.width : 2048
  const height = media ? media.data.attributes.height : 1024

    return (
      <>
     {/* <div className=""> */}
        <Link href="/" className={className}>
          {/* <Image height="56" className="p-0 m-0 w-full h-10" src={nameLogoUrl} alt='Browned & Toasted Home' /> */}
          <Image
              className="p-0 m-0 h-10 w-full"
              alt={alt || "Go to Browned & Toasted Homepage"} 
              width={160}
              height={25}
              priority
              src={url || "/logo.png"}
              style={{ objectFit: 'contain' }}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </Link>
       {/* </div> */}
       </>
      )
  }

export default LogoButton
